import { artifactsClient } from "@artifacts/artifactsClient";
import { useSuspenseQuery } from "@tanstack/react-query";

export const artifactsKeys = {
  list: (sessionKey: string, subject: string | null) =>
    ["artifacts", sessionKey, subject] as const,
};

export const useArtifactsList = (sessionKey: string, subject: string | null) =>
  useSuspenseQuery({
    queryKey: artifactsKeys.list(sessionKey, subject),
    queryFn: () => artifactsClient.list(subject ?? undefined),
  });
